// extracted by mini-css-extract-plugin
export default {"tag":"Tag_tag__TYq0B","tag_zt":"Tag_tag_zt__AVFvt","tag_soft":"Tag_tag_soft__cDtzR"};